const resource = 'auth'

export default $axios => ({
  authWith(provider, params) {
    // Ensure we always use the current protocol (https in production)
    const baseUrl = process.browser ? window.location.origin : this.$config.url
    return $axios.$post(
      `/${resource}/social/${provider}/callback?redirect_url=${baseUrl}/connexion/${provider}`,
      params
    )
  },
  authWithAmazon(provider, token) {
    return $axios.$get(
      `/${resource}/social/${provider}/callback?buyer_token=${token}`
    )
  },
  authWithPaypal(token) {
    return $axios.$post(`/${resource}/social/paypal/callback?code=${token}`)
  },

  fetchAccountAffiliation() {
    return $axios.$get('/v2/account/affiliation')
  },

  fetchAccountMenuCounts() {
    return $axios.$get('/v2/account/menu-counts')
  },

  fetchAccountDashboard() {
    return $axios.$get('/v2/account/dashboard')
  },

  getServiceName: () => 'authService',
})
